export default {
  methods: {
    makeToast(toastType, toastMsg, d) {
      if (false) {
        this.$store.commit('makeToast', { type: toastType, msg: toastMsg, duration: d });
      }
    },
  },
};
